import React from "react";
import { Breadcrumbs, Typography, Box } from "@mui/material";
import { NavLink } from "react-router-dom";
import { titleToUrl } from "../../shared/extra";


const PageBreadcrumb = ({ home, category, other, currentProduct }) => {
  const otherLinkProps = {
    pathname: `/${titleToUrl(other)}`
  }

  // titleToUrl(other)
  // const linkProps = { pathname: '/card-list', search: `categoryIds[]=${category}` };

  const normalBreadCrumbStyle = {
    color: "#B5B5B5",
    fontSize: { xs: "0.9rem", sm: "14px" },
    fontWeight: 400,
    textTransform: { xs: "capitalize", sm: "capitalize" },
    fontFamily: "Be Vietnam Pro"
  };

  const breadCrumbStyle = {
    home: normalBreadCrumbStyle,
    category: normalBreadCrumbStyle,
    currentProduct: {
      fontWeight: 600,
      fontSize: { xs: "0.9rem", sm: "14px" },
      textTransform: { xs: "capitalize", sm: "capitalize" },
      color: "secondary.main",
      fontFamily: "Be Vietnam Pro"
    }
  };

  return (
    <Box
      component="div"
      sx={{
        py: { xs: 0, sm: 1 },
        px: { xs: 0, sm: 1 },
        display: "flex",
        alignItems: "center",
      }}
    >
      <Breadcrumbs aria-label="breadcrumb"
        sx={{
          m: 0,
          p: 0,
          minHeight: 0,
          '& .MuiBreadcrumbs-ol': {
            margin: 0,
            padding: 0,
          }
        }}
      >
        {home && <BreadCrumb title={home} style={breadCrumbStyle.home} link="/" />}
        {other && <BreadCrumb title={other} style={breadCrumbStyle.category} link={otherLinkProps} />}
        {category && <BreadCrumb title={category} style={breadCrumbStyle.category} link={null} />}
        {currentProduct && <BreadCrumb title={currentProduct} style={breadCrumbStyle.currentProduct} />}
      </Breadcrumbs>
    </Box>
  );

  function BreadCrumb({ title, style, link }) {
    return link ? (
      <NavLink
        to={link}
        style={{
          textDecoration: "none",
        }}
      >
        <Typography
          variant="subtitle2"
          sx={style}
        >
          {title}
        </Typography>
      </NavLink>
    ) : (
      <Typography
        variant="subtitle2"
        sx={style}
      >
        {title}
      </Typography>
    );
  }
};

export default PageBreadcrumb;
